import { BaseModel } from './base-model';
import { Map as MGMap } from '@meteogroup/map-layers';

export enum MapEvents {
  ZoomLevelChanged = 'zoom-level-changed'
}

export abstract class VoyMapModelBase extends BaseModel {
    abstract assignMap(map: MGMap): void;
    abstract setZoomLevel(zoom: number): void;
}

let VoyMapModel: VoyMapModelBase | null = null;

function setVoyMapModel(model: VoyMapModelBase) {
  VoyMapModel = model;
}

export { VoyMapModel, setVoyMapModel };
